import React, { Component } from 'react'
import * as styles from './index.module.css'
import { GradientBorder } from '../commons'

export default class DarkIframeContainer extends Component {
  constructor(props) {
    super(props)

    this.state = {
      isMobile: true,
    }
  }

  componentDidMount() {
    if (typeof window !== undefined && window.innerWidth <= 1024) {
      this.state.isMobile = true
      this.setState(this.state)
    } else {
      this.state.isMobile = false
      this.setState(this.state)
    }
  }

  render() {
    var props = this.props

    if (this.state.isMobile == false) {
      return (
        <div className={styles.darkContainer}>
          <div className="wrapper">
            <div className={styles.container}>
              <div className={styles.textContainer}>
                <h3>{props.title}</h3>
                <span>{props.subtitle.subtitle}</span>
              </div>
              <div className={styles.iframeContainer}>
                <iframe
                  src={props.components[0].ctaUrl}
                  scrolling="no"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      )
    } else {
      return <div></div>
    }
  }
}
